module.exports = __webpack_public_path__ + "img/ícone-noticias.41fd54fd.svg";